const enabledLanguageIds = [1, 2];

Object.freeze(enabledLanguageIds);
export default enabledLanguageIds;